import { render, staticRenderFns } from "./top-banner.vue?vue&type=template&id=d632a650&scoped=true&"
import script from "./top-banner.vue?vue&type=script&lang=js&"
export * from "./top-banner.vue?vue&type=script&lang=js&"
import style0 from "./top-banner.vue?vue&type=style&index=0&id=d632a650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d632a650",
  null
  
)

export default component.exports